export const warn = console.warn.bind(console, `[${Date.now()}]`);
export const log = console.log.bind(console, `[${Date.now()}]`);
export const error = console.error.bind(console, `[${Date.now()}]`);
 
export const logging = {
  error,
  warn,
  log,
};